<script setup lang="ts">
import { ComputedRef, Ref, inject, ref } from 'vue';

import { TSDataTable } from 'tsv2-library';
import { MenuOption } from 'tsv2-library/dist/src/components/v2/Menu/Menu.vue';

import {
  childColumns,
  extendRequestColumns,
} from '@/components/common/options/columns';

import useTableStore from '@/store/table.store';

import { BorrowingTransactionRequest } from '@/types/borrowing.type';
import { SettingTransaction } from '@/types/setting-transaction.type';
import RemoveFromList from './Dialog/RemoveFromList.vue';

const { tableKey } = useTableStore();

const settingTransaction = inject(
  'settingTransaction',
) as Ref<SettingTransaction>;

const isLinkedAsset = inject('isLinkedAsset') as ComputedRef<boolean>;

const selectedData = defineModel<BorrowingTransactionRequest[]>(
  'selectedData',
  {
    required: true,
  },
);

const formData = defineModel<Map<string, BorrowingTransactionRequest>>(
  'formData',
  {
    required: true,
  },
);

defineProps<{
  search?: string;
  filters: Record<string, object>;
  data: BorrowingTransactionRequest[];
  usePaginator?: boolean;
}>();

const selectedDatum = ref<BorrowingTransactionRequest>();

const showRemoveFromList = ref<boolean>(false);

const columns = extendRequestColumns(formData, settingTransaction);
const childrenColumns = childColumns();

const singleOptions = ref<MenuOption[]>([
  {
    label: 'Remove from List',
    icon: 'delete-bin',
    danger: true,
    command: (): void => {
      showRemoveFromList.value = true;
    },
  },
]);
</script>
<template>
  <div data-ts-name="borrow-extension-table">
    <RemoveFromList
      v-model:visible="showRemoveFromList"
      :selected-data="selectedDatum ? [selectedDatum] : []"
    />
    <TSDataTable
      :key="tableKey"
      v-model:selected-data="selectedData"
      :children-columns="isLinkedAsset ? childrenColumns : undefined"
      :children-use-option="false"
      :columns
      :data
      :filters
      :options="singleOptions"
      :rows="10"
      :search
      :use-paginator
      @toggle-option="selectedDatum = $event"
      data-key="_id"
      table-name="borrow-extension-table"
    />
  </div>
</template>
